var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJep(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 230.69,
    height: 27.002,
    viewBox: "0 0 230.69 27.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1408",
    "data-name": "Group 1408"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1406",
    "data-name": "Group 1406",
    transform: "translate(77.132 0.051)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1405",
    "data-name": "Group 1405",
    transform: "translate(8.662 1.348)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4109",
    "data-name": "Path 4109",
    d: "M95.555,3.56h1.022V8.95a2.611,2.611,0,0,1-.223,1.162,2.082,2.082,0,0,1-.558.716,1.933,1.933,0,0,1-.716.362,2.881,2.881,0,0,1-.706.1,2.212,2.212,0,0,1-1.348-.409,1.905,1.905,0,0,1-.7-1.236l1-.223a1.171,1.171,0,0,0,.353.669.929.929,0,0,0,.688.242,1.115,1.115,0,0,0,.613-.149,1.1,1.1,0,0,0,.353-.39,1.645,1.645,0,0,0,.167-.548,4.7,4.7,0,0,0,0-.632V3.56Z",
    transform: "translate(-92.33 -1.636)",
    fill: "#203a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4110",
    "data-name": "Path 4110",
    d: "M101.271,3.56V8.207a2.873,2.873,0,0,0,.093.725,1.989,1.989,0,0,0,.325.7,1.673,1.673,0,0,0,.585.52,2.045,2.045,0,0,0,1.784,0,1.673,1.673,0,0,0,.585-.52,2.147,2.147,0,0,0,.316-.7,2.871,2.871,0,0,0,.093-.725V3.56h1.022V8.346a3.132,3.132,0,0,1-.223,1.2,2.788,2.788,0,0,1-.613.929,2.723,2.723,0,0,1-.929.6,3.213,3.213,0,0,1-2.3,0,2.788,2.788,0,0,1-.929-.6,3.076,3.076,0,0,1-.623-.929,3.132,3.132,0,0,1-.223-1.2V3.56Z",
    transform: "translate(-92.888 -1.636)",
    fill: "#203a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4111",
    "data-name": "Path 4111",
    d: "M110.07,3.56h2.649a3.085,3.085,0,0,1,1.19.2,2.017,2.017,0,0,1,.743.5,1.7,1.7,0,0,1,.381.678,2.546,2.546,0,0,1,.112.725,2.01,2.01,0,0,1-1.059,1.756,2.128,2.128,0,0,1-.771.232l2.138,3.439h-1.273l-1.914-3.327H111.12v3.327H110.1V3.56Zm1.022,3.327h1.338a4.275,4.275,0,0,0,.595,0,1.5,1.5,0,0,0,.52-.177.874.874,0,0,0,.362-.372,1.208,1.208,0,0,0,.139-.623,1.208,1.208,0,0,0-.139-.623,1.069,1.069,0,0,0-.362-.372,1.719,1.719,0,0,0-.52-.177,4.163,4.163,0,0,0-.595-.046h-1.338Z",
    transform: "translate(-93.583 -1.636)",
    fill: "#203a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4112",
    "data-name": "Path 4112",
    d: "M118.68,3.56H119.7V11.1H118.68Z",
    transform: "translate(-94.191 -1.636)",
    fill: "#203a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4113",
    "data-name": "Path 4113",
    d: "M123.643,9.531a1.664,1.664,0,0,0,.706.613,2.147,2.147,0,0,0,.929.2,1.738,1.738,0,0,0,.52-.084,1.478,1.478,0,0,0,.483-.242,1.4,1.4,0,0,0,.353-.39,1.031,1.031,0,0,0,.065-.558.827.827,0,0,0-.279-.669,2.546,2.546,0,0,0-.688-.381,8.506,8.506,0,0,0-.929-.3,3.532,3.532,0,0,1-.929-.4,2.2,2.2,0,0,1-.688-.688,2.128,2.128,0,0,1-.279-1.162,1.859,1.859,0,0,1,.149-.706,1.859,1.859,0,0,1,.455-.678,2.593,2.593,0,0,1,.79-.52,2.946,2.946,0,0,1,1.162-.2,4.117,4.117,0,0,1,1.18.167,2.044,2.044,0,0,1,.994.688l-.827.753a1.394,1.394,0,0,0-.548-.483,1.719,1.719,0,0,0-.8-.186,1.905,1.905,0,0,0-.706.112,1.32,1.32,0,0,0-.455.288,1.059,1.059,0,0,0-.242.381,1.143,1.143,0,0,0-.074.372.929.929,0,0,0,.279.734,2.267,2.267,0,0,0,.688.418,9.165,9.165,0,0,0,.929.288,3.8,3.8,0,0,1,.929.353,2.091,2.091,0,0,1,.688.623,1.8,1.8,0,0,1,.279,1.069,2.352,2.352,0,0,1-.2.976,2.2,2.2,0,0,1-.558.734,2.463,2.463,0,0,1-.827.455,3.318,3.318,0,0,1-1.022.158,3.8,3.8,0,0,1-1.375-.251,2.212,2.212,0,0,1-1.032-.79Z",
    transform: "translate(-94.48 -1.622)",
    fill: "#203a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4114",
    "data-name": "Path 4114",
    d: "M131.259,3.56h2.63a4.582,4.582,0,0,1,1.4.186,3.587,3.587,0,0,1,1.041.483,3.1,3.1,0,0,1,.734.7,3.559,3.559,0,0,1,.465.809,4.144,4.144,0,0,1,.242.827,4.645,4.645,0,0,1,.074.762,3.847,3.847,0,0,1-.269,1.4,3.327,3.327,0,0,1-.79,1.2,3.848,3.848,0,0,1-1.292.846,4.647,4.647,0,0,1-1.784.316H131.25V3.56Zm1.022,6.589h1.292a4.033,4.033,0,0,0,1.227-.177,2.974,2.974,0,0,0,1.022-.53,2.491,2.491,0,0,0,.688-.929,2.835,2.835,0,0,0,.251-1.227,3.419,3.419,0,0,0-.121-.846,2.351,2.351,0,0,0-.446-.929,2.6,2.6,0,0,0-.929-.743,3.169,3.169,0,0,0-1.459-.251h-1.533v5.632Z",
    transform: "translate(-95.079 -1.636)",
    fill: "#203a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4115",
    "data-name": "Path 4115",
    d: "M141.54,3.56h1.022V11.1H141.54Z",
    transform: "translate(-95.806 -1.636)",
    fill: "#203a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4116",
    "data-name": "Path 4116",
    d: "M151.564,5.182a2.11,2.11,0,0,0-.809-.641,2.4,2.4,0,0,0-1.05-.223,2.723,2.723,0,0,0-1.152.242,2.593,2.593,0,0,0-.883.66,2.993,2.993,0,0,0-.567.929,3.607,3.607,0,0,0-.186,1.245,3.216,3.216,0,0,0,.2,1.125,2.89,2.89,0,0,0,.558.929,2.667,2.667,0,0,0,.883.641,2.788,2.788,0,0,0,1.18.232,2.388,2.388,0,0,0,1.143-.27,2.426,2.426,0,0,0,.827-.743l.864.651c-.056.074-.158.186-.3.335a3,3,0,0,1-.567.437,3.977,3.977,0,0,1-.846.381,3.568,3.568,0,0,1-1.143.167,3.717,3.717,0,0,1-1.617-.344A4.089,4.089,0,0,1,146.871,10a4.033,4.033,0,0,1-1.041-2.667,4.386,4.386,0,0,1,.288-1.524,3.8,3.8,0,0,1,.8-1.32,3.55,3.55,0,0,1,1.236-.836,4.219,4.219,0,0,1,1.6-.3,3.866,3.866,0,0,1,1.468.288,2.788,2.788,0,0,1,1.18.929Z",
    transform: "translate(-96.109 -1.622)",
    fill: "#203a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4117",
    "data-name": "Path 4117",
    d: "M161.219,5.185a2.11,2.11,0,0,0-.809-.641,2.4,2.4,0,0,0-1.013-.223,2.723,2.723,0,0,0-1.152.242,2.593,2.593,0,0,0-.883.66,2.992,2.992,0,0,0-.567.929,3.382,3.382,0,0,0-.2,1.2,3.215,3.215,0,0,0,.2,1.125,2.891,2.891,0,0,0,.558.929,2.667,2.667,0,0,0,.929.641,2.844,2.844,0,0,0,1.18.232,2.388,2.388,0,0,0,1.143-.27,2.426,2.426,0,0,0,.827-.743l.864.651c-.056.074-.158.186-.3.335a2.732,2.732,0,0,1-.567.437,3.782,3.782,0,0,1-.846.381,3.569,3.569,0,0,1-1.143.167,3.718,3.718,0,0,1-1.617-.344,3.866,3.866,0,0,1-1.227-.929,4.033,4.033,0,0,1-1.041-2.667,4.385,4.385,0,0,1,.242-1.478,3.95,3.95,0,0,1,.8-1.273,3.55,3.55,0,0,1,1.236-.836,4.219,4.219,0,0,1,1.6-.3,3.82,3.82,0,0,1,1.459.288,2.788,2.788,0,0,1,1.18.929Z",
    transform: "translate(-96.796 -1.626)",
    fill: "#203a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4118",
    "data-name": "Path 4118",
    d: "M165.67,3.56h1.022V11.1H165.67Z",
    transform: "translate(-97.511 -1.636)",
    fill: "#203a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4119",
    "data-name": "Path 4119",
    d: "M173.885,11.146a4.034,4.034,0,0,1-1.589-.307A3.717,3.717,0,0,1,171.059,10a3.839,3.839,0,0,1-.809-1.255A4.127,4.127,0,0,1,170,7.187a4.312,4.312,0,0,1,.288-1.561,3.717,3.717,0,0,1,2.045-2.091,4.275,4.275,0,0,1,3.178,0,3.717,3.717,0,0,1,1.236.836,3.838,3.838,0,0,1,.809,1.255,4.126,4.126,0,0,1,.288,1.561,4.275,4.275,0,0,1-.288,1.561,3.717,3.717,0,0,1-2.045,2.091A3.875,3.875,0,0,1,173.885,11.146Zm0-.929a2.7,2.7,0,0,0,2.621-1.868,3.4,3.4,0,0,0,0-2.323,3.03,3.03,0,0,0-.576-.929,2.819,2.819,0,0,0-3.234-.688,2.611,2.611,0,0,0-.929.641,2.788,2.788,0,0,0-.576.929,3.428,3.428,0,0,0-.2,1.162,3.216,3.216,0,0,0,.2,1.162,2.927,2.927,0,0,0,.576.929,2.788,2.788,0,0,0,.929.641,2.7,2.7,0,0,0,1.19.316Zm.409-8.727h1.366L174.07,3.023h-.883Z",
    transform: "translate(-97.817 -1.49)",
    fill: "#203a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4120",
    "data-name": "Path 4120",
    d: "M181.6,3.56h1.3l4.154,6.2h0V3.56h1.022V11.1h-1.3l-4.136-6.2h0v6.2h-1.022V3.56Z",
    transform: "translate(-98.636 -1.636)",
    fill: "#203a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4121",
    "data-name": "Path 4121",
    d: "M93.27,17.48h4.87v.929H94.292v2.249H97.87v.929H94.292V24h4.033v.929H93.27Z",
    transform: "translate(-92.396 -2.62)",
    fill: "#203a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4122",
    "data-name": "Path 4122",
    d: "M102.059,23.432a1.664,1.664,0,0,0,.706.613,2.147,2.147,0,0,0,.929.2,1.738,1.738,0,0,0,.52-.084,1.478,1.478,0,0,0,.483-.242,1.4,1.4,0,0,0,.353-.39,1.032,1.032,0,0,0,.139-.539.827.827,0,0,0-.279-.669,2.546,2.546,0,0,0-.688-.381,8.507,8.507,0,0,0-.929-.3,3.531,3.531,0,0,1-.929-.4,2.2,2.2,0,0,1-.688-.688,2.128,2.128,0,0,1-.279-1.162A2.018,2.018,0,0,1,102,18a2.593,2.593,0,0,1,.79-.52,2.946,2.946,0,0,1,1.162-.2,4.117,4.117,0,0,1,1.18.167,2.045,2.045,0,0,1,.994.688l-.827.753a1.394,1.394,0,0,0-.548-.483,1.719,1.719,0,0,0-.8-.186,1.905,1.905,0,0,0-.706.112,1.32,1.32,0,0,0-.455.288,1.06,1.06,0,0,0-.242.381,1.143,1.143,0,0,0-.074.372.929.929,0,0,0,.279.734,2.268,2.268,0,0,0,.688.418,9.163,9.163,0,0,0,.929.288,3.8,3.8,0,0,1,.929.353,2.091,2.091,0,0,1,.688.623,1.8,1.8,0,0,1,.279,1.069,2.351,2.351,0,0,1-.2.929,2.2,2.2,0,0,1-.558.734,2.463,2.463,0,0,1-.827.455,3.318,3.318,0,0,1-1.022.158,3.8,3.8,0,0,1-1.375-.251,2.212,2.212,0,0,1-1.032-.79Z",
    transform: "translate(-92.96 -2.605)",
    fill: "#203a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4123",
    "data-name": "Path 4123",
    d: "M109.85,17.48H112.5a3.085,3.085,0,0,1,1.19.2,2.017,2.017,0,0,1,.743.5,1.7,1.7,0,0,1,.381.678,2.416,2.416,0,0,1,0,1.45,1.645,1.645,0,0,1-.381.678,1.942,1.942,0,0,1-.743.5,3.123,3.123,0,0,1-1.19.2h-1.58v3.327H109.9Zm1.022,3.318h1.338a4.275,4.275,0,0,0,.567-.046,1.5,1.5,0,0,0,.52-.177.874.874,0,0,0,.362-.372,1.459,1.459,0,0,0,0-1.245,1.069,1.069,0,0,0-.362-.372,1.719,1.719,0,0,0-.52-.177,4.163,4.163,0,0,0-.595-.046h-1.264Z",
    transform: "translate(-93.568 -2.619)",
    fill: "#203a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4124",
    "data-name": "Path 4124",
    d: "M118.25,17.48h4.87v.929h-3.848v2.249h3.578v.929h-3.578V24h4.033v.929H118.25Z",
    transform: "translate(-94.161 -2.62)",
    fill: "#203a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4125",
    "data-name": "Path 4125",
    d: "M132.076,19.088a2.11,2.11,0,0,0-.809-.641,2.4,2.4,0,0,0-1.013-.223,2.723,2.723,0,0,0-1.152.242,2.593,2.593,0,0,0-.883.66,2.993,2.993,0,0,0-.567.976,3.606,3.606,0,0,0-.2,1.2,3.215,3.215,0,0,0,.2,1.125,2.89,2.89,0,0,0,.558.929,2.667,2.667,0,0,0,.883.641,2.788,2.788,0,0,0,1.18.232,2.388,2.388,0,0,0,1.143-.27,2.426,2.426,0,0,0,.827-.743l.864.651c-.056.074-.158.186-.3.335a3,3,0,0,1-.567.437,3.978,3.978,0,0,1-.846.381,3.569,3.569,0,0,1-1.143.167,3.718,3.718,0,0,1-1.617-.344,4.089,4.089,0,0,1-1.227-.929,4.034,4.034,0,0,1-1.041-2.667,4.386,4.386,0,0,1,.288-1.617,3.8,3.8,0,0,1,.8-1.273,3.55,3.55,0,0,1,1.236-.836,4.219,4.219,0,0,1,1.6-.3,3.866,3.866,0,0,1,1.468.288,2.788,2.788,0,0,1,1.18.929Z",
    transform: "translate(-94.734 -2.601)",
    fill: "#203a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4126",
    "data-name": "Path 4126",
    d: "M136.53,17.48h1.022v7.537H136.53Z",
    transform: "translate(-95.452 -2.62)",
    fill: "#203a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4127",
    "data-name": "Path 4127",
    d: "M143.608,17.48h.929l3.225,7.537h-1.19l-.753-1.859h-3.587l-.743,1.859H140.3Zm1.859,4.777-1.4-3.457h0l-1.431,3.457Z",
    transform: "translate(-95.719 -2.62)",
    fill: "#203a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4128",
    "data-name": "Path 4128",
    d: "M151,17.48h1.022v6.58h3.457v.929H151Z",
    transform: "translate(-96.475 -2.62)",
    fill: "#203a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4129",
    "data-name": "Path 4129",
    d: "M163.33,17.48h2.649a3.085,3.085,0,0,1,1.19.2,2.016,2.016,0,0,1,.743.5,1.7,1.7,0,0,1,.381.678,2.416,2.416,0,0,1,0,1.45,1.645,1.645,0,0,1-.381.678,2.017,2.017,0,0,1-.743.5,3.123,3.123,0,0,1-1.19.2h-1.626v3.327H163.33Zm1.022,3.318h1.338a4.275,4.275,0,0,0,.595-.046,1.5,1.5,0,0,0,.52-.177.929.929,0,0,0,.372-.372,1.459,1.459,0,0,0,0-1.245,1.022,1.022,0,0,0-.372-.372,1.72,1.72,0,0,0-.52-.177,4.164,4.164,0,0,0-.595-.046h-1.338Z",
    transform: "translate(-97.346 -2.619)",
    fill: "#203a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4130",
    "data-name": "Path 4130",
    d: "M173.182,17.48h.929l3.225,7.537h-1.19l-.753-1.859h-3.541l-.743,1.859h-1.19Zm1.859,4.777-1.4-3.457h0l-1.422,3.457Z",
    transform: "translate(-97.811 -2.62)",
    fill: "#203a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4131",
    "data-name": "Path 4131",
    d: "M180.55,17.48H183.2a3.085,3.085,0,0,1,1.19.2,2.017,2.017,0,0,1,.743.5,1.7,1.7,0,0,1,.381.678,2.546,2.546,0,0,1,.112.725,2.01,2.01,0,0,1-1.059,1.756,2.082,2.082,0,0,1-.771.232l2.138,3.439h-1.283l-1.933-3.327h-1.143v3.327H180.55Zm1.022,3.318h1.338a4.275,4.275,0,0,0,.595-.046,1.5,1.5,0,0,0,.52-.177.929.929,0,0,0,.372-.372,1.459,1.459,0,0,0,0-1.245,1.022,1.022,0,0,0-.372-.372,1.719,1.719,0,0,0-.52-.177,4.164,4.164,0,0,0-.595-.046h-1.338Z",
    transform: "translate(-98.562 -2.619)",
    fill: "#203a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4132",
    "data-name": "Path 4132",
    d: "M191.448,17.48h.929l3.225,7.537h-1.19l-.753-1.859h-3.587l-.743,1.859h-1.19Zm1.859,4.777L191.9,18.8h0l-1.431,3.457Z",
    transform: "translate(-99.098 -2.62)",
    fill: "#203a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4133",
    "data-name": "Path 4133",
    d: "M203.62,17.48h1.022v6.58H208.1v.929h-4.48Z",
    transform: "translate(-100.192 -2.62)",
    fill: "#203a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4134",
    "data-name": "Path 4134",
    d: "M213.469,17.48h.929l3.225,7.537h-1.19l-.753-1.859h-3.587l-.743,1.859h-1.19Zm1.859,4.777-1.4-3.457h0L212.5,22.257Z",
    transform: "translate(-100.654 -2.62)",
    fill: "#203a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4135",
    "data-name": "Path 4135",
    d: "M225.63,17.48h2.649a3.086,3.086,0,0,1,1.19.2,2.017,2.017,0,0,1,.743.5,1.7,1.7,0,0,1,.409.716,2.407,2.407,0,0,1,0,1.45,1.646,1.646,0,0,1-.381.678,2.017,2.017,0,0,1-.744.5,3.123,3.123,0,0,1-1.19.2H226.68v3.327h-1.022Zm1.022,3.318h1.338a4.275,4.275,0,0,0,.595-.046,1.5,1.5,0,0,0,.52-.177.929.929,0,0,0,.372-.372,1.459,1.459,0,0,0,0-1.245,1.022,1.022,0,0,0-.372-.372,1.719,1.719,0,0,0-.52-.177,4.164,4.164,0,0,0-.595-.046h-1.338Z",
    transform: "translate(-101.747 -2.619)",
    fill: "#203a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4136",
    "data-name": "Path 4136",
    d: "M235.479,17.48h.929l3.225,7.537h-1.19l-.753-1.859H234.1l-.743,1.859h-1.19Zm1.859,4.777-1.4-3.457h0L234.5,22.257Z",
    transform: "translate(-102.209 -2.62)",
    fill: "#203a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4137",
    "data-name": "Path 4137",
    d: "M242.18,24.066l4.294-5.576H242.31V17.56h5.437v.929l-4.266,5.576h4.331v.929H242.18v-.929Z",
    transform: "translate(-102.916 -2.625)",
    fill: "#203a5b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_961",
    "data-name": "Rectangle 961",
    width: 1.459,
    height: 26.951,
    transform: "translate(0 0)",
    fill: "#203a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1407",
    "data-name": "Group 1407"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4138",
    "data-name": "Path 4138",
    d: "M73.548,7.09a8.848,8.848,0,0,0-1.413-3.225,8.262,8.262,0,0,0-3.1-2.649A12.463,12.463,0,0,0,63.046,0H55.128A2.649,2.649,0,0,0,53.4.612a2.612,2.612,0,0,0-.762,1.069,2.844,2.844,0,0,0-.158.613,2.221,2.221,0,0,0,0,.465V26.95h4.284a1.617,1.617,0,0,0,.4-.084,1.859,1.859,0,0,0,.985-.846,1.729,1.729,0,0,0,.139-.307,1.766,1.766,0,0,0,.093-.548v-6.32h4.359a15.307,15.307,0,0,0,3.606-.39,10.167,10.167,0,0,0,5.52-3.262,7.769,7.769,0,0,0,1.487-2.788,10.753,10.753,0,0,0,.2-5.316Zm-7.825,5.92a5.874,5.874,0,0,1-2.454.6H58.39V5.361h4.647a6.106,6.106,0,0,1,2.546.483,3.6,3.6,0,0,1,1.533,1.227,4.117,4.117,0,0,1,.651,2.221A3.829,3.829,0,0,1,65.722,13.01Z",
    transform: "translate(-3.72 0.015)",
    fill: "#203a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4139",
    "data-name": "Path 4139",
    d: "M24.57.24v5.2h20.3V1.718a1.58,1.58,0,0,0,0-.307,1.468,1.468,0,0,0-.539-.846,1.44,1.44,0,0,0-.818-.3Z",
    transform: "translate(-1.75 -0.003)",
    fill: "#203a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4140",
    "data-name": "Path 4140",
    d: "M24.58,27.905v-5.2H45.026v3.717a1.579,1.579,0,0,1,0,.307,1.468,1.468,0,0,1-.539.892,1.44,1.44,0,0,1-.818.3Z",
    transform: "translate(-1.75 -1.591)",
    fill: "#203a5b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_962",
    "data-name": "Rectangle 962",
    width: 18.68,
    height: 5.195,
    transform: "translate(22.83 10.683)",
    fill: "#203a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4141",
    "data-name": "Path 4141",
    d: "M17.389,0V17.509a13.438,13.438,0,0,1-.251,2.574,9.9,9.9,0,0,1-1.125,2.937,7.63,7.63,0,0,1-2.732,2.649,8.56,8.56,0,0,1-2.23.883,12.082,12.082,0,0,1-3.615.4,11.394,11.394,0,0,1-4.647-1.236s-.26-.13-.632-.353A10.139,10.139,0,0,1,.93,24.479L.837,24.4l-.186-.121a1.859,1.859,0,0,1-.6-1.041,1.784,1.784,0,0,1,0-.678,1.719,1.719,0,0,1,.446-.929l2.537-2.788a10.353,10.353,0,0,0,.929.929,8.364,8.364,0,0,0,1.338.994,7.8,7.8,0,0,0,.929.418,4.647,4.647,0,0,0,1.543.279,4.024,4.024,0,0,0,1.924-.4,2.881,2.881,0,0,0,1.19-1.208,4.768,4.768,0,0,0,.474-1.468,9.963,9.963,0,0,0,.093-1.859V2.714A2.723,2.723,0,0,1,12.083.929,2.667,2.667,0,0,1,13.124.167,2.955,2.955,0,0,1,13.886,0Z",
    transform: "translate(-0.015 0.014)",
    fill: "#203a5b"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJep);
export default __webpack_public_path__ + "static/media/jep.00870665bf2c62d7bd2ea7b97a37c3cf.svg";
export { ForwardRef as ReactComponent };